"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var date_1 = require("@internationalized/date");
var ui_tools_1 = require("@ovotech/ui-tools");
var button_1 = require("@react-aria/button");
var calendar_1 = require("@react-aria/calendar");
var i18n_1 = require("@react-aria/i18n");
var react_1 = __importStar(require("react"));
var react_stately_1 = require("react-stately");
var analytics_subjects_1 = require("../../../analytics-subjects");
var internal_tracker_1 = require("../../../internal-tracker");
var component_tooling_1 = require("../../component-tooling");
var Calendar_styled_1 = require("./Calendar.styled");
var CalendarGrid_1 = require("./CalendarGrid");
var NavButton = (0, react_1.forwardRef)(function (props, ref) {
    // useButton doesn't like forwardRefs.
    var buttonProps = (0, button_1.useButton)(props, ref).buttonProps;
    var children = props.children;
    return (react_1.default.createElement(Calendar_styled_1.StyledCalendarNavButton, __assign({}, buttonProps, { ref: ref }), children));
});
function Calendar(props) {
    var _a, _b;
    var Icon = (0, component_tooling_1.useComponents)().Icon;
    var locale = (0, i18n_1.useLocale)().locale;
    var state = (0, react_stately_1.useCalendarState)(__assign(__assign({}, props), { locale: locale, createCalendar: date_1.createCalendar }));
    var buttonPrevRef = (0, react_1.createRef)();
    var buttonNextRef = (0, react_1.createRef)();
    var _c = (0, calendar_1.useCalendar)(props, state), calendarProps = _c.calendarProps, prevButtonProps = _c.prevButtonProps, nextButtonProps = _c.nextButtonProps, title = _c.title;
    return (react_1.default.createElement("div", __assign({}, calendarProps, { "data-testid": "calendar" }),
        react_1.default.createElement(Calendar_styled_1.StyledCalendarHeader, null,
            react_1.default.createElement(Calendar_styled_1.StyledCalendarTitle, null, title),
            react_1.default.createElement(Calendar_styled_1.StyledCalendarNav, null,
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DATEPICKER_CALENDAR_NAV, properties: (_a = {}, _a[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _a.direction = 'previous', _a) },
                    react_1.default.createElement(NavButton, __assign({ type: "button" }, prevButtonProps, { ref: buttonPrevRef }),
                        react_1.default.createElement(Icon, { name: "chevron-left", size: 16 }))),
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DATEPICKER_CALENDAR_NAV, properties: (_b = {}, _b[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _b.direction = 'next', _b) },
                    react_1.default.createElement(NavButton, __assign({ type: "button" }, nextButtonProps, { ref: buttonNextRef }),
                        react_1.default.createElement(Icon, { name: "chevron-right", size: 16 }))))),
        react_1.default.createElement(CalendarGrid_1.CalendarGrid, { state: state })));
}
exports.Calendar = Calendar;
